/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
export default (video) => video?.type.toLowerCase() === 'youtube' || /vimeo/i.test(video?.video_id);
